import DatePicker from "react-datepicker";
import getLocale from '../date-fns-locale';
import "react-datepicker/dist/react-datepicker.css";
import { getCalendarStartDay, getDataFromGlobalVars, getFeeForDate } from '../helper';
import { isAfter, format } from 'date-fns';

const WdsDatePicker = ({
	handleDateChange,
	bookableDates,
	selected,
	id,
	maxDate,
} ) => {
	const locale = getLocale();
	const dateFormat = getDataFromGlobalVars('date_fns_format');

	/**
	 * Is this date allowed to be selected?
	 *
	 * @param Date date
	 * @returns bool
	 */
	const isAllowedDay = function ( date ) {
		if ( ! bookableDates ) {
			return true;
		}

		if (maxDate && isAfter(date, maxDate)) {
			return false;
		}
		
		const ymd = format(date, 'yyyyMMdd');
		return bookableDates.some( function ( bookable_date ) {
			return bookable_date.ymd === ymd;
		} );
	}

	/**
	 * Render Tooltip span for each day cell.
	 *
	 * @param String day
	 * @param Date date
	 * @returns 
	 */
	const renderDayContents = ( day, date ) => {
		const tooltipText = getFeeForDate( date );
		return <span aria-label={tooltipText} className={ isAllowedDay(date) ? 'iconic-wds-date--tooltip' : ''}>{day}</span>;
	};

	const onChange = ( date ) => {
		// Dispatch event to hide tooltip.
		jQuery( document.body ).trigger( 'iconic_wds_selected_date_changed' );
		handleDateChange( date );
	}

	return (
		<div className="wds-block-field-wrapper wds-block-field-wrapper--date">
			<DatePicker
				selected={selected}
				onChange={onChange}
				filterDate={isAllowedDay}
				id={id}
				locale={locale}
				dateFormat={dateFormat}
				calendarStartDay={getCalendarStartDay()}
				renderDayContents={renderDayContents}
				autoComplete="off"
				placeholderText={getDataFromGlobalVars('strings').selectdate}
			/>
		</div>
	);
};

export default WdsDatePicker;
